import { boolean, object, string } from 'yup'

const InternalCansSchema = object().shape({
  agent: string()
    .required('TGB Common ID is required')
    .matches(
      /^(?!\s*$)[-a-zA-Z\-.,'\s]+$/,
      'TGB Common ID can only contain letters and basic punctuation',
    )
    .trim(),
  title: string()
    .required('Title is required')
    .min(1, 'Title must be at least 2 characters')
    .max(10, 'Title must be at most 10 characters')
    .trim(),
  first_name: string()
    .required('First name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'First name can only contain letters and basic punctuation',
    )
    .min(2, 'First name must be at least 2 characters')
    .max(50, 'First name must be at most 50 characters')
    .trim(),
  last_name: string()
    .required('Last name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'Last name can only contain letters and basic punctuation',
    )
    .min(2, 'Last name must be at least 2 characters')
    .max(50, 'Last name must be at most 50 characters')
    .trim(),
  email: string()
    .required('Email is required')
    .matches(
      /^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/,
      'Email must be a valid email address',
    )
    .max(255)
    .trim(),
  tel: string()
    .required('Phone is required')
    .matches(/^\d{7,11}$/, {
      message: 'Please enter a valid telephone number',
      excludeEmptyString: true,
    })
    .trim(),
  customer_cans_consent: string().oneOf(
    ['yes'],
    'Please make the customer aware that their data is being transferred to the Centre',
  ),
  model: string().required('Model is required'),
  type_of_enquiry: string().required('Type of Enquiry is required'),
  current_car_make: string().when('type_of_enquiry', {
    is: (value) => ['Part Exchange'].includes(value),
    then: (rule) => rule.trim().required('Current Car Make is required'),
  }),
  current_car_model: string().when('type_of_enquiry', {
    is: (value) => ['Part Exchange'].includes(value),
    then: (rule) => rule.trim().required('Current Car Model is required'),
  }),
  current_car_reg: string().when('type_of_enquiry', {
    is: (value) => ['Part Exchange'].includes(value),
    then: (rule) =>
      rule
        .trim()
        .matches(
          /(^[a-zA-Z]{2}[0-9]{2}\s?[a-zA-Z]{3}$)|(^[a-zA-Z][0-9]{1,3}[a-zA-Z]{3}$)|(^[a-zA-Z]{3}[0-9]{1,3}[a-zA-Z]$)|(^[0-9]{1,4}[a-zA-Z]{1,2}$)|(^[0-9]{1,3}[a-zA-Z]{1,3}$)|(^[a-zA-Z]{1,2}[0-9]{1,4}$)|(^[a-zA-Z]{1,3}[0-9]{1,3}$)|(^[a-zA-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)/,
          'Current Car Registration is invalid',
        )
        .required('Current Car Registration is required'),
  }),
  dealer: string().required('Please select an option'),
  consent: object({
    user: boolean(),
  }),
  is_lexus: boolean(),
  user: boolean(),
})

export default InternalCansSchema
